<template>
    <table class="table table-bordered p-2">
        <thead>
            <th>Dato</th>
            <th>Valor (Dotted Decimal)</th>
            <th>Valor (Binario)</th>
        </thead>
        <tbody>
            <tr>
                <th>IP</th>
                <td>{{ ipaddress }}</td>
                <td class="text-monospace">{{ ipaddressbin }}</td>
            </tr>
            <tr>
                <th>Clase</th>
                <td>{{ ipclass }}</td>
                <td>N/A</td>
            </tr>
            <tr>
                <th>Máscara (por defecto)</th>
                <td>{{ ipmask }}</td>
                <td class="text-monospace">{{ ipmaskbin }}</td>
            </tr>
            <tr>
                <th>Dirección de Red</th>
                <td>{{ ipnetaddr }}</td>
                <td class="text-monospace">{{ ipnetaddrbin }}</td>
            </tr>
            <tr>
                <th>Primera IP</th>
                <td>{{ ipnetfirst }}</td>
                <td class="text-monospace">{{ ipnetfirstbin }}</td>
            </tr>
            <tr>
                <th>Ultima IP</th>
                <td>{{ ipnetlast }}</td>
                <td class="text-monospace">{{ ipnetlastbin }}</td>
            </tr>
            <tr>
                <th>Broadcast</th>
                <td>{{ ipnetbcast }}</td>
                <td class="text-monospace">{{ ipnetbcastbin }}</td>
            </tr>
            <tr>
                <th>Equipos</th>
                <td>{{ ipnethosts }}</td>
                <td class="text-monospace">N/A</td>
            </tr>
        </tbody>
    </table>
</template>

<script>

import iputils from "../lib/iputils";

export default {
    props: ["ipaddress"],
    computed: {
        ipclass: function() {
            return iputils.getClassFromIP(this.ipaddress);
        },
        ipaddressbin: function ()  {
            return iputils.isValidIP(this.ipaddress) ?
                iputils.stringToBinary(this.ipaddress) :
                '';
        },
        ipmask: function () {
            return iputils.getDefaultMaskForClass(this.ipclass);
        },
        ipmaskbin: function() {
            return (this.ipmask.length > 0) ?
                iputils.stringToBinary(this.ipmask) :
                '';
        },
        ipnetaddr: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getMaskSubnet(this.ipaddress, this.ipmask).networkAddress :
                '';
        },
        ipnetaddrbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(this.ipnetaddr) :
                '';
        },
        ipnetfirst: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getMaskSubnet(this.ipaddress, this.ipmask).firstAddress :
                '';
        },
        ipnetfirstbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(iputils.getMaskSubnet(this.ipaddress, this.ipmask).firstAddress) :
                '';
        },
        ipnetlast: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getMaskSubnet(this.ipaddress, this.ipmask).lastAddress :
                '';
        },
        ipnetlastbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(iputils.getMaskSubnet(this.ipaddress, this.ipmask).lastAddress) :
                '';
        },
        ipnetbcast: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getMaskSubnet(this.ipaddress, this.ipmask).broadcastAddress :
                '';
        },
        ipnetbcastbin: function() {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.stringToBinary(iputils.getMaskSubnet(this.ipaddress, this.ipmask).broadcastAddress) :
                '';
        },
        ipnethosts: function () {
            return (iputils.isNetIPClass(this.ipclass)) ?
                iputils.getMaskSubnet(this.ipaddress, this.ipmask).numHosts :
                '';
        }
    }
}
</script>